<div class="mds-layout">
  <mc-top-bar product="MGF SSO Test Client" productshort="SSO Test Client">
    <a slot="link" routerLink="/" routerLinkActive="active">Dashboard</a>
    <app-avatar-dropdown slot="actions"></app-avatar-dropdown>
  </mc-top-bar>
  <mc-side-bar>
    <nav class="mds-tree-nav" role="navigation" aria-label="side navigation">
      <ul>
        <li>
          <a routerLink="/"
             routerLinkActive="mds-tree-nav__active"
             [routerLinkActiveOptions]="{ exact: true }"
             #homeLink="routerLinkActive"
             [attr.aria-current]="homeLink.isActive ? 'page' : null">
             <mc-icon icon="door-arrow-right-in"></mc-icon>Login</a>
        </li>
        <li>
          <a routerLink="/callback"
             routerLinkActive="mds-tree-nav__active"
             [routerLinkActiveOptions]="{ exact: false }"
             #clientsSearchLink="routerLinkActive"
             [attr.aria-current]="clientsSearchLink.isActive ? 'page' : null">
             <mc-icon icon="container-left"></mc-icon>Callback</a>
        </li>
      </ul>
    </nav>
  </mc-side-bar>
  <router-outlet />
</div>
